import React, { ReactElement } from 'react';
import { Tooltip } from '@mui/material';
//@ts-ignore
import { makeStyles } from '@mui/styles';

import { ToolTipProps } from './types';

const useStyles = makeStyles(() => ({
  tooltip: {
    borderRadius: '8px !important',
    fontSize: '12px !important',
    lineHeight: '16px !important',
    fontWeight: 400,
    padding: '8px !important',
    fontFamily: 'Poppins, sans-serif !important',
    wordBreak: 'break-all',
  },
  darkArrow: { color: 'var(--neutral-n-900) !important' },
  lightArrow: { color: '#ffffff !important' },
  tooltipDarkBackground: { backgroundColor: 'var(--neutral-n-900) !important', color: '#fff' },
  tooltipLightBackground: {
    backgroundColor: '#ffffff !important',
    color: '#353535 !important',
    fontWeight: '400 !important',
    width: '260px !important',
    height: '50px !important',
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    fontSize: '15px !important',
    boxShadow: '1px 1px 8px 0px rgba(115, 87, 233, 0.30) !important',
  },
}));

export default function CustomTooltip({
  title,
  children,
  arrow = true,
  placement = 'bottom',
  light = false,
  show = true,
  opened,
  tooltipStyle = {},
  ...rest
}: ToolTipProps) {
  const classes = useStyles();

  if (!show) return <>{children}</>;

  return (
    <Tooltip
      title={title}
      open={opened}
      classes={{
        tooltip: `${classes.tooltip} ${light ? classes.tooltipLightBackground : classes.tooltipDarkBackground}`,
        arrow: `${light ? classes.lightArrow : classes.darkArrow}`,
      }}
      componentsProps={{
        tooltip: {
          sx: {
            //added this to shift new word to next line. This will avoid word breaking in tooltips
            wordBreak: 'break-word',
            fontFamily: 'Poppins',
            fontWeight: 400,
            ...tooltipStyle,
          },
        },
      }}
      arrow={arrow}
      placement={placement}
      {...rest}>
      {children}
    </Tooltip>
  );
}
